// 中文语言包
export default {
        // 通用
    siteTitle: 'Ai情报管理系统',

    // 语言选择
    language: '语言',
    switchToEnglish: '切换为英文',
    switchToChinese: '切换为中文',
    switchToVietnamese: '切换为越南语',

    // 认证重定向
    authRedirect: {
        verifying: '正在验证登录信息...',
        processing: '正在处理登录请求...',
        invalidToken: '未获取到有效的登录信息',
        verificationFailed: '登录验证失败',
        loginSuccess: '登录成功',
        getUserInfoFailed: '获取用户信息失败',
    },

    // 侧边栏
    dashboard: '仪表盘',
    reports: '报告管理',
    templates: '报告模板',
    svgmaker: '文生PPT',
    settings: '系统设置',
    onelineReport: '规划模式',
    intelligenceQuery: '情报查询',
    logout: '退出登录',

    // 用户菜单
    profile: '个人信息',
    accountSettings: '账号设置',

    // 面包屑
    home: '首页',

    // 仪表盘页面
    welcomeBack: '欢迎回来',
    totalReports: '总报告数',
    newReportsThisMonth: '本月新增报告',
    reportTemplates: '报告模板',
    templateVersions: '模板总版本',
    comparedToLastMonth: '较上月',
    recentActivity: '最近活动',
    viewAll: '查看全部',
    reportsOverTime: '报告趋势',
    completedReports: '已完成报告',
    reportsInProgress: '进行中报告',
    myRecentReports: '我的报告',
    createNewReport: '创建新报告',
    monthly: '月度',
    quarterly: '季度',
    yearly: '年度',
    createdNewReport: '创建了新报告',
    updatedReport: '更新了报告',
    createdNewTemplate: '创建了新模板',

    // 状态标签
    draft: '草稿',
    inProgress: '进行中',
    completed: '已完成',
    review: '审核中',
    archived: '已归档',

    // 模板管理页面
    templateManagement: '模板管理',
    allTemplates: '所有模板',
    myTemplates: '我的模板',
    sharedTemplates: '共享模板',
    createTemplate: '创建模板',
    searchTemplates: '搜索模板...',
    templateName: '模板名称',
    templateDesc: '模板描述',
    category: '分类',
    creator: '创建者',
    createDate: '创建日期',
    usageCount: '使用次数',
    version: '版本',
    actions: '操作',
    editTemplate: '编辑模板',
    duplicateTemplate: '复制模板',
    deleteTemplate: '删除模板',
    shareTemplate: '共享模板',
    templateCategories: '模板分类',
    recentlyUsed: '最近使用',
    popular: '热门模板',
    newest: '最新模板',

    // 报告管理页面
    reportManagement: '报告管理',
    allReports: '全部报告',
    myReports: '我的报告',
    sharedWithMe: '共享给我的',
    archivedReports: '已归档报告',
    searchReports: '搜索报告...',
    filterByStatus: '按状态筛选',
    filterByDate: '按日期筛选',
    filterByTemplate: '按模板筛选',
    sortBy: '排序方式',
    oldest: '最旧的',
    lastUpdated: '最近更新',
    reportName: '报告名称',
    template: '模板',
    createdDate: '创建日期',
    updatedDate: '更新日期',
    status: '状态',
    action: '操作',
    batchActions: '批量操作',
    export: '导出',
    archive: '归档',
    delete: '删除',
    batchDelete: '批量删除',
    itemsPerPage: '每页显示',
    prev: '上一页',
    next: '下一页',
    goToPage: '跳转到',

    // 报告详情
    reportDetail: '报告详情',
    edit: '编辑',
    view: '查看',
    reportInfo: '报告信息',
    basicInfo: '基本信息',
    reportContent: '报告内容',
    addQuestion: '添加问题',
    editQuestion: '编辑问题',
    deleteQuestion: '删除问题',
    addAnswer: '添加回答',
    saveChanges: '保存更改',
    cancel: '取消',
    questionCategories: '问题分类',
    allCategories: '所有分类',
    searchQuestions: '搜索问题...',
    questionCount: '问题数',
    answerRate: '回答率',
    compare: '对比',
    print: '打印',
    share: '分享',
    comments: '评论',
    timeline: '时间线',
    activity: '活动',

    // 创建报告页面
    createNewReportLong: '创建新的调查报告',
    createReportDesc: '请选择一个报告模板并填写基本信息来创建新的调查报告',
    selectTemplate: '选择模板',
    selectPlanType: '选择方案类型',
    confirmCreate: '确认创建',
    searchTemplate: '搜索模板...',
    nextSelectPlanType: '下一步：选择方案类型',
    prevSelectTemplate: '上一步：选择模板',
    reportTopicContent: '报告主题与内容',
    nextConfirmCreate: '下一步：确认创建',
    prevSelectPlanType: '上一步：选择方案类型',
    confirmReportInfo: '确认报告信息',
    selectedTemplate: '选择的模板',
    confirmCreateReport: '确认创建报告',
    notes: '注意事项',
    note1: '创建报告后，您可以随时编辑和保存报告内容',
    note2: '系统会自动保存您的编辑记录和版本历史',
    note3: '报告创建后默认状态为"草稿"，完成后可提交审核',
    plans: '个方案',
    categories: '个分类',
    questions: '个问题',
    includedCategories: '包含的分类',
    alreadyCreated: '已创建',
    createdReports: '份报告',
    madeBy: '制作',
    system: '系统',
    pleaseSelectValidTemplate: '请先选择一个有效的模板',
    pleaseEnter: '请输入',
    creating: '创建中...',

    // 时间相关
    today: '今天',
    yesterday: '昨天',
    daysAgo: '{n}天前',
    weeksAgo: '{n}周前',
    unknownDate: '未知日期',

    // 新增键值
    fullscreen: '全屏',
    confirmLogout: '确定要退出登录吗?',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    // 导入页面模块
    templatesList: {
		pageTitle: '模板管理',
		pageSubtitle: '管理和组织您的报告模板',
		createTemplate: '创建模板',
		categoryManagement: '分类管理',
		templateType: '模板类型',
		totalTemplates: '总模板数',
		templateName: '模板名称',
		templateDesc: '模板描述',
		allTemplates: '全部模板',
		categories: '分类',
		search: '搜索',
		searchCategories: '搜索分类',
		fieldName: '字段名称',
		type: '类型',
		publishState: '发布状态',
		publish: '已发布',
		unpublish: '未发布',
		goPublish: '去发布',
		cancelPublish: '取消发布',
		creator: '创建者',
		createTime: '创建时间',
		operations: '操作',
		view: '查看',
		noData: '暂无数据',
		otherType: '其他类型',
		dragSortSuccess: '拖拽排序成功，点击保存按钮保存更改',
		confirmDelete: '此操作将永久删除该项, 是否继续?',
		tip: '提示',
		confirm: '确定',
		cancel: '取消',
		deleteSuccess: '删除成功',
		deleteCancelled: '已取消删除',
		nameRequired: '名称不能为空',
		saveSuccess: '保存成功',
		saveFailed: '保存失败',
		createSuccess: '创建成功',
		createFailed: '创建失败',
		pleaseEnter: '请输入',
		saveChanges: '保存更改',
		editNote: '修改备注',
		pleaseEnterEditNote: '请输入修改备注',
		getTemplateListFailed: '获取模板列表失败',
		unsavedChangesTip: '你已对模板进行编辑、现在退出将放弃目前的编辑效果。建议保存后再退出',
		// 模板详情抽屉
		templateDetail: '模板详情',
		editTemplateInfo: '编辑模板',
		copyTemplateInfo: '复制为新模板',
		confirmCopyTemplate: '复制的新模板归属权为你所有，且不影响已有模板，是否继续？',
		description: '描述',
		noDescription: '暂无描述',
		researchContext: '研究上下文字段',
		noContextFields: '暂无研究上下文字段',
		reportStructure: '报告结构',
		addChapter: '添加章节',
		// 节点编辑抽屉
		add: '添加',
		edit: '编辑',
		parentChapter: '所属章节',
		chapterName: '章节名称',
		subChapterName: '子章节名称',
		subChapterQuestion: '子章节问题',
		chapterPrompt: '章节提示词',
		subChapterPrompt: '子章节提示词',
		// 分类管理抽屉
		categoryManager: '分类管理',
		addCategory: '新增分类',
		editCategory: '编辑分类',
		categoryName: '分类名称',
		categoryDesc: '分类描述',
		categoryAdmin: '管理人员',
		categoryViewer: '查看人员',
		addAdmin: '添加管理员',
		addViewer: '添加查看者',
		selectAdmin: '选择管理员',
		selectViewer: '选择查看者',
		sortOrder: '排序',
		categoryCount: '模板数量',
		categoryActions: '操作',
		categoryDeleteTip: '该分类下有模板，无法删除',
		categorySystemTip: '系统内置分类无法删除',
		categoryDeleteConfirm: '确定要删除该分类吗？',
		categoryDeleteSuccess: '删除分类成功',
		categoryDeleteFailed: '删除分类失败',
		categorySaveSuccess: '分类保存成功',
		categorySaveFailed: '分类保存失败',
		categoryCreateSuccess: '分类创建成功',
		categoryOrderUpdateSuccess: '分类顺序已更新',
		categoryOrderUpdateFailed: '更新分类顺序失败',
		dragSortTip: '您可以用来调整分类顺序',
		deleteTip: '数量为0的模板才可以删除',
		// 新增模板表单
		newTemplate: '新增模板',
		templateTitle: '模板标题',
		templateDesc: '模板描述',
		researchContextFields: '研究上下文字段',
		addField: '添加字段',
		prompt: '提示词',
		titleRequired: '模板名称不能为空',
		typeRequired: '请选择模板分类',
		descRequired: '模板描述不能为空',
		creatorRequired: '创建人不能为空',
		// 权限相关
		permission: '权限',
		private: '仅个人使用',
		public: '分类内部公开',
		// 状态提示
		loading: '加载中...',
		operationSuccess: '操作成功',
		operationFailed: '操作失败',
		getUserPermissionFailed: '获取用户权限失败',
		selectCreateMethod: '选择创建方式',
		importQuestionList: '导入问题清单创建',
		importQuestionListDesc: '导入问题清单，Ai整理章节后创建模板',
		aiGenerateOutline: 'Ai生成大纲后创建',
		aiGenerateOutlineDesc: '使用 Ai，通过对话方式完善报告模板再生成',
		manualCreate: '手动创建',
		manualCreateDesc: '输入模板基础信息，创建结构化报告',
		importQuestionListTitle: '导入问题清单',
		questionListPlaceholder: `请输入问题清单，每个问题之间用换行分隔。如：
标的开发适应症在中国患者数、能够诊断出的患者数和会就诊的患者数
该产品的API和制剂生产成本预估、中国医保定价预估
同靶点同适应症的竞品在中国销售额的预估，以及在中国可能实现销售额的预估
是否存在合作可能性低，或临床开发风险大，或合作代价高，或注册风险大，或专利风险大的情况`,
		confirmRestoreVersion: '确定恢复到版本 {version} 吗？',
		versionHistory: '版本历史',
		currentVersion: '当前版本',
		restoreToThisVersion: '恢复到此版本',
		modifiedBy: '修改人',
		versionRestoreSuccess: '成功恢复到版本 {version}',
		delete: '删除',
		confirmDelete: '确认删除吗？',
		deleteFailed: '删除失败',
		noVersionHistory: '暂无历史版本',
		getTemplateTypeFailed: '获取模板类型失败',
		versionDetail: '版本详情',
		noVersionDetail: '暂无版本详情',
		changeTemplateStateFailed: '修改模板状态失败',
		versionCount: '共 {count} 个版本',
		answerType: '回答类型',
		generalAi: '通用Ai',
		structuredData: '结构数据',
		pleaseSelect: '请选择',
		searchMethod: '搜索方式',
		networkSearch: '联网搜索',
		aiSearch: '本地搜索',
		networkSearchTip: '联网搜索将搜索互联网的信息\n本地搜索只使用本地知识库或文件内容',
		presetDatabase: '预置知识库',
		clickToSelect: '点击选择',
		selectPermission: '请选择权限',
		promptRequired: '提示词不能为空',
		selectKnowledgeBase: '选择知识库',
		deepSearch: '规划模式',
		ragSearchTip: '适用于文件数据量较大的场景、由大模型增强检索后、只将与问题相关的内容提取给Ai',
		directSearchTip: '只适用于文件数据不多时、将文件内容全部提取给Ai',
		ragSearch: 'RAG增强检索',
		directSearch: '直接检索',
		aiType: 'AI模型',
	},
    svgMaker: {
        pageTitle: 'SVG图表生成器',
        pageSubtitle: '使用AI技术，将您的文本描述转换为精美的SVG图表',
        createButton: '创建新图表',
        historyTitle: '历史记录',
        recordCount: '共{count}条记录',
        emptyState: '暂无历史记录',
        generatingStatus: '生成中',
        viewDetails: '查看详情',
        createDialogTitle: '创建SVG图表',
        dialogHeader: '创建新图表',
        dialogSubtitle: '请输入您想要生成的图表描述',
        dialogGeneratingHeader: '正在生成图表',
        dialogGeneratingSubtitle: '系统正在根据您的描述构建SVG图表，请稍候...',
        inputDescription: '请详细描述您想要的图表，包括类型、样式、数据等信息',
        inputPlaceholder: '例如：生成一个展示2023年各季度销售数据的柱状图，使用蓝色主题',
        demandsToggle: '高级设置',
        demandsCustomTag: '自定义',
        demandsDescription: '您可以在这里添加更详细的生成要求',
        demandsPlaceholder: '例如：使用渐变色、添加动画效果、调整字体大小等',
        analysisStep: '分析需求',
        extractionStep: '提取关键信息',
        structureStep: '构建图表结构',
        renderingStep: '渲染SVG',
        generatingTitle: '正在生成图表...',
        generationSuccess: '图表生成成功',
        resultTitlePlaceholder: '请输入图表标题',
        regenerateButton: '重新生成',
        downloadButton: '下载SVG',
        completeButton: '完成',
        cancel: '取消',
        generateImage: '生成图表',
        preparing: '准备中...',
        generating: '生成中...',
        regenerate: '重新生成',
        complete: '完成',
        tip: '提示',
        confirm: '确定',
        editButton: '编辑',
        error: {
          minLength: '为保证图片输出质量，请输入至少20个字符的文本内容',
          createTask: '创建任务失败',
          fetchTasks: '获取图片任务列表失败',
          generationFailed: '图片生成失败: {message}',
          generationFailedPrefix: '生成失败 - ',
          saveFailed: '保存失败，请重试'
        },
        unnamedChart: '未命名图表',
        currentUser: '当前用户',
        imageSaved: '图片已保存',
        generatingChart: '正在生成图表...',
        unknownUser: '未知用户',
        message: {
          enterEditMode: '已进入编辑模式',
          preparingEditor: '正在准备编辑器...',
          editorUnavailable: '获取SVG内容失败，编辑功能不可用',
          svgContentUnavailable: '无法获取SVG内容，编辑功能不可用',
          exitEditMode: '已退出编辑模式',
          saveSuccess: '保存成功',
          svgDownloadSuccess: 'SVG下载成功',
          svgEncodingFailed: 'SVG编码失败，无法下载',
          preparingDownload: '正在准备下载...',
          svgFetchFailed: '获取SVG失败',
          svgContentFetchFailed: '获取SVG内容失败，无法下载'
        }
      },
    reportsList: {
		pageTitle: '报告管理',
		pageSubtitle: '管理您创建的所有分析报告',
		createNewReport: '创建新报告',
		reportType: '报告类型',
		reportStatus: '报告状态',
		reportSource: '报告来源',
		searchPlaceholder: '搜索报告标题或内容',
		totalReports: '报告总数',
		inProgress: '进行中',
		completed: '已完成',
		view: '查看',
		creator: '创建人',
		createTime: '创建时间',
		operations: '操作',
		noData: '没有找到匹配的报告',
		noDataTip: '请尝试调整筛选条件或搜索关键词',
		createOptions: {
			title: '选择创建方式',
			deepSearch: {
				title: '一句话立即创建',
				desc: '只需要一句话输入、智能搜索资料，生成高质量专业报告'
			},
			ai: {
				title: '生成报告大纲后创建',
				desc: '使用 Ai，通过对话方式完善报告大纲、再生成完整报告内容'
			},
			template: {
				title: '已有模版创建',
				desc: '选择行业专业模板，快速创建结构化报告'
			}
		},
		status: {
			notStarted: '未开始',
			inProgress: '进行中',
			completed: '已完成',
			failed: '失败',
			unknown: '未知'
		},
		source: {
			normal: '普通报告',
			scheduled: '定时报告',
			system: '系统报告'
		},
		reportTitle: '报告标题',
		newTag: '新',
		defaultType: 'Ai报告'
	},
    reportDetailModule: {
        loadingText: "正在获取报告详情",
        confirmText: "如果你觉得这个回复对你有帮助，请点击确认按钮，我会把上面的这段回复更新到本章节中。\n\n <更新到本章节>",
        download: "下载",
        downloading: "下载中",
        saveToKnowledge: "另存到知识库",
        reportType: "报告类型",
        template: "模板",
        creator: "创建人",
        createTime: "创建时间",
        reportId: "报告编号",
        aiModel: "AI模型",
        temperature: "温度",
        researchBackground: "研究背景",
        reportSections: "报告章节",
        aiSuggestions: "AI修订",
        aiFeedbackAssistant: "AI反馈助手",
        you: "你",
        from: "来自",
        generating: "生成中",
        confirmGenerate: "确认生成",
        inputPlaceholder: "请输入想要与AI交流的内容",
        status: {
          notStarted: "未开始",
          inProgress: "进行中",
          completed: "已完成",
          failed: "失败",
          unknown: "未知"
        },
        error: {
          fetchFailed: "获取报告详情失败",
          fetchAiModelsFailed: "获取AI模型失败",
          downloadLinkInvalid: "下载链接不可用",
          updateFailed: "更新失败",
          saveToKnowledgeFailed: "保存到知识库失败",
          fetchChatMessagesFailed: "获取聊天消息失败",
          startChatFailed: "启动聊天会话失败",
          generationFailed: "章节生成失败",
          errorCount: "当前有 {count} 个章节生成失败",
          retryFailed: "重新生成任务失败"
        },
        success: {
          updateSuccess: "更新成功",
          saveToKnowledgeSuccess: "保存到知识库成功",
          retrySuccess: "重新生成任务已启动"
        },
        aiAssistant: "AI助手",
        welcomeMessage: "你好！我是AI反馈助手，可以帮你分析和改进本报告中的【{section}】内容。有什么需要我协助的吗？",
        thinking: "思考中",
        nextChapter: "下一章",
        clickToContinue: "点击继续阅读",
        lastChapter: "已经是最后一章了",
        cancel: "取消",
        save: "保存",
        edit: "编辑",
        unknownModel: "未知模型",
        confirmEditDiscard: "您有正在编辑的内容，是否放弃之前的编辑？",
        prompt: "提示",
        discard: "放弃",
        share: '分享',
        shareSuccess: '分享链接已复制到剪贴板',
        shareFailed: '复制分享链接失败',
        versionHistory: '历史版本',
        retry: '重新生成',
        retrying: '重新生成中',
      },
      versionList: {
        title: '版本对比',
        baseVersion: '基准版本',
        selectVersionToCompare: '选择要对比的版本',
        compare: '对比',
        clearCompareVersion: '清除对比版本',
        selectVersion: '选择版本',
        latestVersion: '最新版本',
        version: '版本',
        reviser: '修订人',
      },
    createReport: {
        steps: ['选择报告分类', '选择报告模板', '填写报告内容', '确认报告信息'],
        sectionTitle: '选择报告分类',
        sectionDesc: '请选择您需要创建的报告类型',
        typeBadge: '个模板',
        footerStat: '已创建',
        footerStat2: '份',
        subsectionTitle: '选择模板',
        subsectionDesc: '已选择分类：',
        fillContentTitle: '填写报告内容',
        fillContentDesc: '已选择模板：',
        templateMeta: '等',
        templateMeta2: '个分析模块',
        moreSettings: '更多设置',
        temperatureHint: '较高的温度会使AI生成的内容更具创造性，较低的温度使结果更加确定和可预测',
        aiModelHint: '不同的AI模型在创造力、速度和效率方面各有特点',
        confirmTitle: '确认报告信息',
        confirmDesc: '请确认以下信息无误后创建报告',
        confirmSection1: '报告类型',
        confirmSection2: '报告内容',
        confirmSection3: '报告分析内容',
        reportAnalysisTitle: '报告分析内容',
        associatedKnowledge: '已关联背景知识',
        srcType: {
            knowledgeBase: '通用AI',
            deepSearch: '规划模式',
            mcp: 'MCP',
            custom: '结构数据'
        },
        confirmSection4: 'AI生成设置',
        confirmLabel1: '分类：',
        confirmLabel2: '模板：',
        confirmLabel3: '描述：',
        confirmLabel4: 'AI模型：',
        confirmLabel5: '温度参数：',
        noticeTitle: '注意事项',
        notice1: '创建报告后，你可以随时编辑和保存报告内容',
        notice2: '系统会自动保存你的编辑记录和版本历史',
        notice3: '报告创建需要时间、默认状态为"进行中"，请耐心等待创建完成',
        prevStep: '上一步',
        nextStep: '下一步',
        createReport: '确认创建报告',
        creating: '创建中...',
        error1: '获取模板类型失败',
        error2: '获取AI模型失败',
        error3: '获取模板失败',
        error4: '请填写完所有报告内容后再继续',
        success: '报告创建成功！',
        error5: '报告创建失败，请重试',
        temperature: '温度',
        aiModel: 'AI模型',
        selectAiModel: '请选择AI模型',
        opportunityOverview: '机会概述',
        opportunityOverviewRequired: '请输入机会概述',
        opportunityOverviewPlaceholder: '可输入本次报告的已知信息或相关备注、如不需要可填写无',
        unknownModel: '未知模型',
        fieldRequired: '请输入{field}',
        fieldPlaceholder: '请输入{field}'
        ,
        // 模板分析区域新增
        analysisQuestions: '{count} 个分析问题',
        associateKnowledgeBtn: '关联背景知识',
        notSupported: '不支持',
        selectKnowledgeBase: '选择知识库',
        myCreatedTag: '我创建的',
        noNeedToFill: '无须填写内容',
        reportTitle: '报告标题',
        reportTitlePlaceholder: '请输入报告标题，如不填写将自动生成'
    },
    aiChat: {
        chatTitle: 'Ai生成大纲后创建',
        deepSearchTitle: 'Ai立即创建',
        closeConfirm: '您还未完成与Ai情报助手的对话，确定要退出吗？',
        closeReportConfirm: '您还未生成报告，确定要退出吗？',
        inputPlaceholder: '请输入想要与Ai情报交流的内容',
        confirmGenerate: '确认生成',
        thinking: '思考中',
        fullscreen: '全屏显示',
        exitFullscreen: '退出全屏',
        close: '关闭',
        generatingReport: '正在生成AI报告...',
        reportInitialized: '报告大纲已成功初始化',
        goGenerate: '去生成',
        cancel: '取消',
        generating: '生成中...',
        reportStructure: '报告内容结构',
        cancelReport: '您已取消报告生成。如需继续，请告诉我您的需求。',
        error: '发生错误',
        sendError: '发送消息失败，请重试',
        initError: '初始化会话失败，请重试',
        getTemplateError: '获取模板数据失败，请重试',
        unknownModel: '未知模型',
        you: '你',
        aiAssistant: 'Ai情报助手',
        introText: '你好！我是Ai情报助手，可以帮助你创建报告。请告诉我你想要生成什么报告、我会与你一起完善报告大纲后、再生成报告。',
        deepSearchIntroText: '你好！我是Ai情报助手，从生活答疑到专业知识，从创意构思到任务规划，我都能搞定！输入关键词或具体问题，即刻解锁高效、精准的智能服务。',
        templateIntroText: '你好！我是Ai情报助手，可以帮助你创建模板。请告诉我你想要生成什么模板、我会与你一起完善模板大纲后、再生成模板。',
        missingParams: '缺少报告生成参数',
        reportCreated: '报告创建成功！',
        reportCreateError: '报告创建失败，请重试',
        tip: '提示',
        confirm: '确定',
        generateTemplate: '生成模板',
        selectTemplate: '选择模板类型',
        templateType: '模板类型',
        selectTemplateType: '请选择模板类型',
        templateCreated: '模板创建成功',
        templateCreateError: '模板创建失败',
        getTemplateTypesError: '获取模板类型失败',
        reportTaskCreated: '报告创建成功',
        userPaused: '用户已暂停',
        newChatConfirmPC: '您还未完成与Ai情报助手的对话，确定要开启新对话吗？',
        newChatConfirmMobileWithReport: '是否确认开启新的对话？当前报告可以在报告列表中查看。',
        newChatConfirmMobileNoReport: '您还未完成与Ai情报助手的对话，当前对话会丢失，确定要开启新的对话吗？',
        timeFormat: {
            month: '月',
            day: '日',
            timeSeparator: ':'
        }
    },
    addGroup: {
        title: '设置分组',
        commonContacts: '常用联系人',
        people: '人',
        createNewGroup: '新建分组',
        cancel: '取消',
        confirm: '确定',
        newGroupTitle: '新建分组',
        enterGroupName: '请输入分组名称',
        selectCategory: '请选择类别',
        category: '类别',
        groupNameRequired: '请输入分组名称',
        addToGroupSuccess: '添加分组成功',
        addToGroupFailed: '添加分组失败',
        createGroupSuccess: '创建分组成功',
        createGroupFailed: '创建分组失败'
      },
    leftArea: {
        searchPlaceholder: '搜索名字、拼音、职称...',
        noSearchResults: '-无搜索结果-',
        leaveStatus: '(已离职)',
        commonContacts: '常用联系人',
        recentContacts: '最近联系人',
        commonContact: '常用联系人',
        recentContact: '最近联系人',
        setGroup: '设置分组',
        setAsCommonContact: '设为常用联系人',
        operationSuccess: '操作成功',
        alreadyAdded: '已添加，请勿重复操作',
        limitExceeded: '仅允许添加{count}个人员',
        duplicateSelection: '不能重复选择',
        noDuplicateSelection: '不能重复选择',
        people: '人'
      },
    rightArea: {
        title: '右侧区域',
        searchPlaceholder: '搜索',
        selectAll: '全选',
        setGroup: '设置分组',
        noSelection: '请先选择项目',
        operationSuccess: '操作成功',
        setCommonContact: '设为常用联系人',
        removeCommonContact: '移出常用联系人',
        myGroup: '我的分组',
        maxDeptLimit: '仅允许添加{max}个部门',
        maxPeopleLimit: '仅允许添加{max}个人员',
        alreadyAdded: '已添加，请勿重复操作',
        alreadyRemoved: '已移出，请勿重复操作',
        expand: '展开',
        retract: '收起',
        rename: '重命名',
        nextLevel: '下级',
        people: '人'
    },
    svgEditor: {
        title: 'SVG 图片编辑模式',
        subtitle: '在此模式下您可以添加、编辑或删除文本元素，拖动文本调整位置',
        addText: '添加文本',
        removeSelected: '删除选中',
        resetBackground: '恢复原图',
        exitEdit: '退出编辑',
        save: '保存',
        undo: '撤销',
        redo: '重做',
        zoomLabel: '缩放',
        resetZoom: '重置',
        fontSize: '字号',
        fontFamily: '字体',
        color: '颜色',
        charSpacing: '字间距',
        lineHeight: '行距',
        textAlign: '多行文本对齐',
        textStyle: '文字样式',
        bold: '加粗',
        italic: '倾斜',
        underline: '下划线',
        strikethrough: '中划线',
        alignLeft: '左',
        alignCenter: '中',
        alignRight: '右',
        alignSelection: '对齐方式',
        multiAlignTitle: '多元素对齐',
        alignLeftEdge: '左对齐',
        alignHCenter: '水平居中',
        alignRightEdge: '右对齐',
        alignTopEdge: '顶部对齐',
        alignVCenter: '垂直居中',
        alignBottomEdge: '底部对齐',
        enterFullscreen: '全屏',
        exitFullscreen: '退出全屏',
        textPanelTitle: '文本属性',
        textPlaceholder: '直接在此处修改文本内容',
        preview: '预览',
        download: '下载',
        previewTitle: '画布预览',
        previewPlaceholder: '预览生成中...',
        previewClose: '关闭',
        previewFailed: '生成预览失败，请重试',
        downloadSuccess: '已开始下载',
        downloadFailed: '下载失败，请重试',
        defaultText: '双击编辑文本',
        confirmExit: '确定要放弃所有更改并恢复到原始状态吗？',
        confirm: '提示',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        successMessage: '已恢复到原始状态',
        saveError: '保存失败，请重试',
    },
    database: {
        title: '数据库管理',
        subtitle: '在此页面中，您可以管理和查看数据库信息',
        addRecord: '添加记录',
        removeRecord: '删除记录',
        save: '保存',
        cancel: '取消',
        confirm: '确认',
        searchPlaceholder: '搜索数据库...',
        confirmDelete: '您确定要删除此记录吗？',
        successMessage: '操作成功',
        errorMessage: '操作失败，请重试',
        goToPage: '定位到第',
        page: '页',
        preview: '预览',
        subFolder: '下级',
        selectedCount: '已选',
        item: '项',
        maxSelect: '最多可选择',
        knowledgeBase: '知识库',
        created: '创建',
    },
    onelineReportPage: {
        historyPanel: '历史会话',
        newButton: '新建',
        noResult: '暂无结果',
        loadMore: '滚动加载更多',
        noMoreData: '没有更多数据了',
        loading: '加载中',
        userTitle: '你',
        aiTitle: 'AI助手',
        getHistoryFailed: '获取历史记录失败',
        stateMap: {
            0: '未开始',
            1: '进行中',
            2: '已完成',
            3: '失败'
        },
        emptyHistory: '暂无历史记录',
        aiAssistant: 'AI助手',
        timeFormat: {
            month: '月',
            day: '日',
            timeSeparator: ':'
        },
        latestChat: '已是最新的对话',
        chatCompletedPrefix: '当前智能对话已完成，如需继续探索请点击',
        deleteSessionConfirm: '确定删除会话"{name}"吗？',
        deleteSessionTitle: '提示',
        deleteSessionConfirmBtn: '确定',
        deleteSessionCancelBtn: '取消',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        deleteFailedRetry: '删除失败，请重试'
    },
    feedback: {
        button: '有建议？点击反馈',
        title: '帮助我们优化系统！您的反馈是进步的动力~',
        placeholder: '遇到问题？有新需求？请您提供详细的信息，我们将快速处理~请您尽量提供详细的信息，可以帮助我们更快定位问题了，例如报告标题，使用的功能等',
        cancel: '取消',
        submit: '立即反馈',
        success: '感谢您的反馈！',
        error: '反馈提交失败，请稍后重试'
    },
    intelligenceQueryPage: {
        inputPlaceholder: '请输入你的问题...',
        generating: '生成中',
        errorAiService: '网络异常，请稍后重试。',
    },
} 